import type { Step } from 'react-joyride';
import { TourDefinition } from '../useTour';

export const getChannelsTour = ( activeFlags: string[], t: any ): TourDefinition => {
    const steps: Step[] = [
        {
        target: '#tour-app',
        placement: 'center',
        title: t(
            'channels_tour_title',
            'This are your channels' 
        ),
        content: (
            <div style={{ textAlign: 'center' }}>
            <p>
                {t(
                'channels_tour_description',
                'Aca podras vincular tus canales'
                )}
            </p>
            </div>
        )
        },
        {
        target: '#tour-add-channel-button',
        placement: 'bottom',
        title: t(
            'channels_tour_step1_title',
            'Add a new channel' 
        ),
        content: (
            <div style={{ textAlign: 'center' }}>
            <p>
                {t(
                'channels_tour_step1_description',
                'If you click this button you can add a new channel'
                )}
            </p>
            </div>
        )
        },
        {
        target: '#tour-channel-list',
        placement: 'bottom',
        title: t(
            'channels_tour_step2_title',
            'Your channels list' 
        ),
        content: (
            <div style={{ textAlign: 'center' }}>
            <p>
                {t(
                 'channels_tour_step2_description',
                 'Once you add a channel, it will appear in this list. You can manage your channels here.'
                )}
            </p>
            </div>
        )
        },
        {
        target: '#tour-app',
        placement: 'center',
        title: t(
            'channels_tour_finish_title',
            'Thats it!' 
        ),
        content: (
            <div style={{ textAlign: 'center' }}>
            <p>
                {t(
                 'channels_tour_finish_description',
                 'You can now manage your channels. Click on a channel to see more details of it.'
                )}
            </p>
            </div>
        )
        }
    ];
    return {
      key: 'channels',
      name: t( 'channels_tour_name' ),
      description: t( 'channels_tour_description' ),
      route: '/channels',
      steps
    };
};